import { IAssetReport, IqueryParams } from "../../config/types";
import { buildQueryString } from "../../utils/buildQueryString";
import { apiService } from "../api.service";

const createAssetReport = async (
  data: {
    issue: string;
    comments: string;
    resolution: string;
    asset_ids: string[];
  },
  evidence_images?: File[],
) => {
  const formData = new FormData();

  const assetReportData = {
    issue: data.issue,
    comments: data.comments,
    resolution: data.resolution,
    asset_ids: data.asset_ids,
  };

  formData.append("asset_report", JSON.stringify(assetReportData));

  if (evidence_images && evidence_images.length > 0) {
    evidence_images.forEach((file) => {
      formData.append("evidence_images", file);
    });
  }

  return apiService.apiRequest<IAssetReport>(
    "post",
    "asset-reports",
    formData,
    {
      "Content-Type": "multipart/form-data",
    },
  );
};

const getAssetReports = async (
  queryParams?: IqueryParams<{
    issue?: string;
    search?: string;
  }>,
) => {
  const query = buildQueryString(queryParams);
  return apiService.apiRequest<IAssetReport[]>("get", `asset-reports${query}`);
};

const getAssetReport = async (reportId: string) => {
  return apiService.apiRequest<IAssetReport>(
    "get",
    `asset-reports/${reportId}`,
  );
};

const updateAssetReport = async (
  reportId: string,
  data: {
    issue?: string;
    comments?: string;
    resolution?: string;
    removed_evidence_images?: string[];
    removed_asset_ids?: string[];
    newly_added_asset_ids?: string[];
  },
  evidence_images?: File[],
) => {
  const formData = new FormData();

  formData.append("update_data", JSON.stringify(data));

  if (evidence_images && evidence_images.length > 0) {
    evidence_images.forEach((file) => {
      formData.append("evidence_images", file);
    });
  }

  return apiService.apiRequest<IAssetReport>(
    "put",
    `asset-reports/${reportId}`,
    formData,
    {
      "Content-Type": "multipart/form-data",
    },
  );
};

const deleteAssetReport = async (reportId: string) => {
  return apiService.apiRequest<any>("delete", `asset-reports/${reportId}`);
};

export const assetReportApi = {
  createAssetReport,
  getAssetReports,
  getAssetReport,
  updateAssetReport,
  deleteAssetReport,
};
